module.exports = __webpack_public_path__ + "img/3.78528c5c.jpg";